import { Form } from 'semantic-ui-react'
import { suridataApi } from '../../services/api'
import { toast } from 'react-toastify'
import { useState } from 'react'


export default function Login() {
    const [isLoading, setIsLoading] = useState(false)

    function handleSubmit(e) {
        e.preventDefault()

        setIsLoading(true)

        const data = new FormData(e.target)
        const email = data.get('email')
        const password = data.get('password')
        const secret = process.env.REACT_APP_SURIDATA_API_SECRET

        suridataApi
            .post('/auth', { email, password, secret })
            .then((response) => {
                localStorage.setItem('token', response.data.token)
                localStorage.setItem('email', email)
                window.location.reload()
            })
            .catch((error) => {
                toast.error('E-mail ou senha inválidos')
            })
            .finally(() => {
                setIsLoading(false)
            })
    }

    return (
        <>
            <Form onSubmit={(e) => handleSubmit(e)}>
                <Form.Field>
                    <label>E-mail</label>
                    <input
                        name="email"
                        placeholder="meu.email@suridata.com.br"
                    />
                </Form.Field>
                <Form.Field>
                    <label>Senha</label>
                    <input
                        name="password"
                        placeholder="Senha"
                        type="password"
                    />
                </Form.Field>
                <Form.Button
                    primary
                    type="submit"
                    fluid
                    loading={isLoading}
                    disabled={isLoading}
                >
                    Entrar
                </Form.Button>
            </Form>
        </>
    )
}
